import React, { createContext, useState } from 'react';
import { loadProduct, preloadProductsAndFilterOffers } from '../core/products';
import { Offer, Product } from '../domain';

type LoadProductArgs = {
  products: Product[];
  shopify_product_handle: string;
};

type PreloadProductsResult = {
  offers: Offer[];
  products: Product[];
};
export interface ProductsContextProps {
  loadProduct: (args: LoadProductArgs) => void;
  getProduct: (handle: string) => Product | undefined;
  getTargetProduct: (handle: string) => Product | undefined;
  loadTargetProduct: (args: LoadProductArgs) => void;
  preloadProductsAndFilterOffers: (
    offers: Offer[],
  ) => Promise<PreloadProductsResult>;
}

const ProductsContext = createContext<ProductsContextProps>({
  loadProduct: () => void 0,
  getProduct: () => void 0,
  loadTargetProduct: () => void 0,
  getTargetProduct: () => void 0,
  preloadProductsAndFilterOffers: () => {
    return Promise.resolve({ offers: [], products: [] });
  },
});

type ProductsContextProviderProps = {
  children: React.ReactNode;
  storefrontAccessToken?: string;
};

export function ProductsContextProvider({
  children,
  storefrontAccessToken,
}: ProductsContextProviderProps) {
  const [products, setProducts] = useState({});
  const [targetProducts, setTargetProducts] = useState({});

  function setProduct(handle, data) {
    setProducts((prevState) => ({
      ...prevState,
      [handle]: data,
    }));
  }

  function setTargetProduct(handle, data) {
    setTargetProducts((prevState) => ({
      ...prevState,
      [handle]: data,
    }));
  }

  return (
    <ProductsContext.Provider
      value={{
        loadProduct: (args) =>
          loadProduct({ ...args, setProduct, storefrontAccessToken }),
        getProduct: (handle) => products[handle],
        loadTargetProduct: (args) =>
          loadProduct({
            ...args,
            setProduct: setTargetProduct,
            storefrontAccessToken,
          }),
        getTargetProduct: (handle) => targetProducts[handle],
        preloadProductsAndFilterOffers: (offers) =>
          preloadProductsAndFilterOffers(
            offers,
            setProduct,
            setTargetProduct,
            storefrontAccessToken,
          ),
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
}

export default ProductsContext;
